export interface TenantFeaturesModel {
  manageProviders: boolean;
  manageServiceTypes: boolean;
  manageLocationServices: boolean;
  managePricing: boolean;
  autoCopyCustomerNotes: boolean;
  googleTagManagerId: string | null;
}

export const defaultTenantFeatures: TenantFeaturesModel = {
  manageProviders: true,
  manageServiceTypes: true,
  manageLocationServices: true,
  managePricing: true,
  autoCopyCustomerNotes: false,
  googleTagManagerId: null,
};

export default TenantFeaturesModel;
